"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicroBundle = void 0;
var react_1 = __importStar(require("react"));
var bundle_provider_1 = require("../services/bundle-provider");
var suspense_resource_storage_1 = require("../services/suspense-resource-storage");
var resourceStorage = new suspense_resource_storage_1.SuspenseResourceStorage();
function MicroBundle(_a) {
  var name = _a.name,
    path = _a.path,
    _a$props = _a.props,
    props = _a$props === void 0 ? {} : _a$props,
    rest = __rest(_a, ["name", "path", "props"]);
  var resource = resourceStorage.getOrAdd(name, path, function () {
    return bundle_provider_1.bundleProvider.getBundle(name, path);
  });
  var Component = resource.read();
  react_1.useEffect(function () {
    return function () {
      resourceStorage.delete(name, path);
    };
  }, []);
  return react_1.default.createElement(Component, Object.assign({}, rest, props));
}
exports.MicroBundle = MicroBundle;